import "./styles/App.css";
import "./styles/App.sass";
import "@fontsource/zen-old-mincho";
import "video-react/dist/video-react.css";
// 最後載入：防擴充功能洗掉背景（高權重 !important 搶救關鍵背景）
import "./styles/harden.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Alpha from "./pages/Alpha";
import BranchList from "./pages/BranchList";
import Branch1 from "./pages/Branch1";
import Charity from "./pages/Charity";
import Charity1 from "./pages/charity_page1";
import Charity2 from "./pages/charity_page2";
import Charity3 from "./pages/charity_page3";
import Charity4 from "./pages/charity_page4";
import TemplateA from "./pages/TemplateA";
import SocialActivity from "./pages/SocialActivity";
import EliteRecruitment from "./pages/EliteRecruitment";
import FocusActivities from "./pages/FocusActivities";
import KryptoGo from "./pages/KryptoGo";
import About from "./pages/About";
import Page from "./pages/page";
import Page2 from "./pages/page2";
import Page3 from "./pages/page3";
import Article from "./pages/article";
import Reward from "./pages/reward";
import Buddhism from "./pages/buddhism";
import Buddhism1 from "./pages/buddhism1";
import Buddhism2 from "./pages/buddhism2";
import Buddhism3 from "./pages/buddhism3";
import Buddhism4 from "./pages/buddhism4";
import { BuddhismLesson } from "./pages/BuddhismLesson";
import BuddhismIntro from "./pages/buddhismIntro";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/article" element={<Article />} />
        <Route path="/page" element={<Page />} />
        <Route path="/page2" element={<Page2 />} />
        <Route path="/page3" element={<Page3 />} />
        <Route path="/charity" element={<Charity />} />
        <Route path="/charity1" element={<Charity1 />} />
        <Route path="/charity2" element={<Charity2 />} />
        <Route path="/charity3" element={<Charity3 />} />
        <Route path="/charity4" element={<Charity4 />} />
        <Route path="/about" element={<About />} />
        <Route path="/alpha" element={<Alpha />} />
        <Route path="/branchList" element={<BranchList />} />
        <Route path="/branch1" element={<Branch1 />} />
        <Route path="/KryptoGo" element={<KryptoGo />} />
        <Route path="/templateA" element={<TemplateA />} />
        <Route path="/socialActivity" element={<SocialActivity />} />
        <Route path="/eliteRecruitment" element={<EliteRecruitment />} />
        <Route path="/focusActivities" element={<FocusActivities />} />
        <Route path="/reward" element={<Reward />} />
        <Route path="/buddhism" element={<Buddhism />} />
        <Route path="/buddhism1" element={<Buddhism1 />} />
        <Route path="/buddhism2" element={<Buddhism2 />} />
        <Route path="/buddhism3" element={<Buddhism3 />} />
        <Route path="/buddhism4" element={<Buddhism4 />} />
        <Route path="/buddhismIntro" element={<BuddhismIntro />} />
        <Route path="/buddhismLesson" element={<BuddhismLesson />} />
      </Routes>
    </Router>
  );
};

export default App;
